import { createFileRoute } from '@tanstack/react-router'
import { HeaderLayout, OfferPage } from 'merchant-components'

export const Route = createFileRoute('/application/$id/offer')({
  component: () => <HeaderLayout outlet={<OfferPage />} />
})

